<template>
  <div>
    <v-card
      flat
      color="#e1f6ff"
      :loading="loading"
      style="border: 1px solid #d9d9d9 !important"
      outlined
      ><div class="d-flex flex-row flex-wrap pa-2">
        <div>
          <div
            v-if="companyObj && companyObj.image"
            class="companyImage pl-4 pr-8"
          >
            <v-img
              :src="companyPath + companyObj.image"
              max-width="200"
              height="60"
              contain
              eager
              position="left center"
            ></v-img>
          </div>
          <div v-else class="mx-4 mt-2">
            <div class="text-h5">
              <span v-if="companyObj"> {{ companyObj.name }} </span>
              <!-- <span v-if="pageTitle"> {{ tagObj.name | titleize }} </span> -->
            </div>
            <div class="text-h5 d-flex flex-row align-center">
              <div v-if="tagTypeImage" class="pr-2" style="width: 50px">
                <v-img
                  :src="tagTypeImage"
                  max-width="40"
                  max-height="40"
                  contain
                  eager
                ></v-img>
              </div>
              <div>{{ pageTitle | titleize }}</div>
            </div>
          </div>
        </div>
        <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
        <div>
          <v-btn-toggle
            v-if="!companyObj"
            v-model="groupBy"
            rounded
            class="my-2 my-sm-0"
            active-class="activeToggle"
          >
            <v-btn x-small value="companyId" v-if="!companyObj"
              ><v-icon x-small class="mr-2">mdi-factory</v-icon>Group by
              Company</v-btn
            >
            <v-btn x-small :value="null"
              ><v-icon x-small class="mr-2">mdi-format-list-text</v-icon
              >List</v-btn
            >
          </v-btn-toggle>
        </div>
      </div>
      <div class="d-flex flex-row flex-wrap align-center pa-2">
        <div style="max-width: 300px">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Filter by Name"
            single-line
            hide-details
            outlined
            dense
            rounded
            clearable
            background-color="#FFF"
            class="compact-select mb-2"
            @blur="searchChange()"
            @keyup.enter="searchChange()"
            ref="searchInput"
          ></v-text-field>
        </div>
        <div v-if="selectCompanyOptions && !company" style="max-width: 300px">
          <v-select
            v-model="filters.company"
            label="Filter by Company"
            :items="selectCompanyOptions"
            hide-details
            outlined
            dense
            rounded
            clearable
            background-color="#FFF"
            class="compact-select mb-2"
          ></v-select>
        </div>
        <div
          v-if="lensTypesForResults && lensTypesForResults.length > 1"
          class="mr-4"
        >
          <!-- {{ lensTypesForResults }} -->
          <v-btn-toggle rounded v-model="filters.lensType" class="mb-2">
            <v-btn :value="null" small>Any Type</v-btn>
            <v-btn
              small
              v-for="lensType in lensTypesForResults"
              :key="lensType"
              :value="lensType"
              >{{ typeOptions[lensType] }}</v-btn
            >
          </v-btn-toggle>
        </div>
        <v-btn
          small
          text
          color="primary"
          @click="showMoreTags = !showMoreTags"
          v-if="tagIdsForResults.allowedTags"
          class="pb-2"
          ><v-icon color="primary" small class="mr-2">mdi-tune</v-icon>
          {{ showMoreTags ? "Hide" : "More" }} Filters</v-btn
        >

        <!-- <v-btn small text color="primary" @click="showTags = !showTags"
          ><v-icon color="primary" small class="mr-2">mdi-tune</v-icon>More
          Filters</v-btn
        > -->
      </div>
      <rgp-tag-selector
        class="mx-4 pb-2"
        v-if="rgpOptions"
        :rgpOptions="rgpOptions"
        :tagGroups="rgpOptions.tagGroups"
        :activeTags="filters.tags"
        :allowedTags="tagIdsForResults.allowedTags"
        :universalTags="tagIdsForResults.universalTags"
        :mainTag="mainTag"
        :showMore="showMoreTags"
        @tags="filters.tags = $event"
      >
        <!--     :tags="rgpOptions.tags" -->
      </rgp-tag-selector>
    </v-card>
    <!-- <v-divider class="mb-6"></v-divider> -->
    <div
      class="caption mt-2 d-flex flex-row flex-wrap"
      v-if="filterSummary && filterSummary.length"
    >
      <b>Current Filters:</b>
      <div class="d-flex flex-row flex-wrap align-start">
        <v-chip
          outlined
          x-small
          label
          v-for="(item, i) in filterSummary"
          :key="'summary_' + i"
          class="mx-1 mt-1"
          @click="summaryChipClicked(item)"
        >
          {{ item.label | titleize
          }}<v-icon x-small class="ml-2">mdi-close</v-icon></v-chip
        >
      </div>
      <v-spacer></v-spacer>
      <v-btn color="red" text x-small @click="clearFilters()"
        >Clear All Filters</v-btn
      >
    </div>
    <!-- {{ lenses }} -->
    <div v-if="lenses" class="mt-4">
      <v-data-table
        :loading="loading"
        :headers="headersForSize"
        :items="filteredLenses"
        :items-per-page="50"
        :hide-default-header="isMobile"
        @click:row="rowClick"
        :group-by="groupBy"
        class="pointer"
        dense
      >
        <!--         hide-default-footer
 -->

        <template v-slot:group.header="{ group, items, isOpen, toggle }">
          <td
            :colspan="headersForSize.length"
            @click="toggle"
            style="padding: 0; background-color: #fff !important"
          >
            <div style="height: 2em" v-if="isOpen"></div>
            <div
              class="d-flex flex-row"
              :class="{ viewWidth: isMobile }"
              style="
                background-color: rgb(239 247 250);
                border: 1px solid #92c1e0;
                min-height: 55px;
                width: 100%;
                padding: 5px 1em;
              "
            >
              <div>
                <div
                  v-if="groupBy == 'companyId'"
                  class="d-flex flex-row align-center"
                >
                  <!-- {{
                    companyForItem(items[0]) ? companyForItem(items[0]) : " - "
                  }} -->
                  <div style="width: 200px" class="mr-4">
                    <v-img
                      :src="companyImageForId(items[0].companyId)"
                      height="30"
                      width="150"
                      contain
                      position="left center"
                      class="my-2"
                    >
                      <!-- <template v-slot:placeholder>
                      <div class="mx-4 text-h4">
                        {{ companyNameForId(items[0].companyId) }}
                      </div>
                    </template> -->
                    </v-img>
                  </div>
                  <h3>
                    {{ companyNameForId(items[0].companyId) }}
                  </h3>
                </div>
              </div>
              <v-spacer></v-spacer>
              <v-btn
                text
                icon
                small
                color="primary"
                class="ma-1"
                :ref="group"
                :data-open="isOpen"
              >
                <v-icon>{{
                  isOpen ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
            </div>
          </td>
        </template>

        <template v-slot:item.image="{ item }">
          <div class="py-2">
            <v-img
              v-if="item.image"
              :src="imgPath + item.image"
              contain
              max-width="100"
              max-height="35"
              position="left center"
            >
            </v-img>
            <v-img
              v-else-if="companyImageForId(item.companyId)"
              :src="companyImageForId(item.companyId)"
              height="30"
              width="100"
              contain
              position="left center"
            >
              <template v-slot:placeholder>
                <div class="">
                  {{ companyNameForId(item.companyId) | truncate(20) }}
                </div>
              </template>
            </v-img>
          </div>
        </template>
        <template v-slot:item.lens="{ item }">
          <div class="font-weight-medium">{{ item.lens }}</div>
        </template>

        <template v-slot:item.presbyopia="{ item }">
          <check-or-minus
            :val="lensHasTag(item.tags, 'presbyopia')"
          ></check-or-minus>
        </template>
        <template v-slot:item.toric="{ item }">
          <check-or-minus
            :val="lensHasTag(item.tags, 'toric')"
          ></check-or-minus>
        </template>

        <!-- <template v-slot:item.corneal="{ item }">
          <check-or-minus :val="item.lensType == 'corneal'"></check-or-minus>
        </template> -->
        <template v-slot:item.scleral="{ item }">
          <check-or-minus :val="item.lensType == 'scleral'"></check-or-minus>
        </template>
        <template v-slot:item.ortho-k="{ item }">
          <check-or-minus :val="item.lensType == 'ortho-k'"></check-or-minus>
        </template>

        <template v-slot:item.unoHeader="{ item }">
          <div class="d-flex flex-row justify-start my-2">
            <div class="imgDiv">
              <v-img
                v-if="item.image"
                :src="imgPath + item.image"
                contain
                max-width="100"
                max-height="80"
                position="left center"
              ></v-img>
            </div>
            <div class="text-left">
              <div class="text-h5">{{ item.lens }}</div>
              <div class="caption">{{ item.company }}</div>

              <div class="d-flex flex-row flex-wrap mt-3">
                <div class="d-flex flex-row pr-2">
                  Presbyopia
                  <check-or-minus
                    :val="lensHasTag(item.tags, 'presbyopia')"
                  ></check-or-minus>
                </div>
                <div class="d-flex flex-row pr-2">
                  Toric
                  <check-or-minus
                    :val="lensHasTag(item.tags, 'toric')"
                  ></check-or-minus>
                </div>

                <div class="d-flex flex-row pr-2">
                  Scleral
                  <check-or-minus
                    :val="item.lensType == 'scleral'"
                  ></check-or-minus>
                </div>
                <div class="d-flex flex-row pr-2">
                  Ortho-K
                  <check-or-minus
                    :val="item.lensType == 'ortho-k'"
                  ></check-or-minus>
                </div>
              </div>
            </div>
          </div>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
// import Name from "../dir/file";
import ApiServices from "@/services/ApiServices";
import CheckOrMinus from "@/components/universalStuff/CheckOrMinus";
import RgpOptionsMixin from "@/assets/js/rgps/RgpOptionsMixin.js";
import FiltersMixin from "@/assets/js/cls/FiltersMixin";
import RgpTagSelector from "./RgpTagSelector.vue";
// import RgpFiltersForType from "./RgpFiltersForType.vue";

export default {
  name: "RgpList",
  props: {
    isAdmin: null,
    rgpOptions: null,
  },
  components: {
    CheckOrMinus,
    // RgpFiltersForType,
    RgpTagSelector,
  },
  mixins: [RgpOptionsMixin, FiltersMixin],
  data: function () {
    return {
      loading: false,
      search: "",
      company: null,
      lensType: null, // 'scleral', 'corneal', or 'ortho-k'
      tag: null,
      groupBy: null,
      showTags: false,
      imgPath: "https://www.eyedock.com/images/rgp_media/",
      companyPath: "https://www.eyedock.com/images/rgp_companies/",
      iconPath: "https://eyedock.com/images/menu_icons/",
      lenses: [],
      meta: null,
      filters: { search: null, company: null, tags: [], lensType: null }, // if changed, also change clearFilters() method
      showMoreTags: false,
      headers: [
        { text: "Image", value: "image" },
        { text: "Lens", value: "lens" },
        { text: "Company", value: "company" },
        { text: "Toric", value: "toric" },
        { text: "Presbyopia", value: "presbyopia" },
        // { text: "Corneal", value: "corneal" },
        { text: "Scleral", value: "scleral" },
        { text: "Ortho-K", value: "ortho-k" },
      ],
      mobileHeader: [{ text: "", value: "unoHeader" }],
      typeOptions: {
        corneal: "Corneal",
        scleral: "Scleral",
        "ortho-k": "Ortho-K / CRT",
      },
    };
  },
  methods: {
    getLenses() {
      this.loading = true;
      let paramArr = [];
      if (this.tag) paramArr.push("tag=" + this.tag);
      if (this.lensType) paramArr.push("lensType=" + this.lensType);
      if (this.company) paramArr.push("company=" + this.company);
      let paramStr = paramArr.length ? "?" + paramArr.join("&") : "";
      ApiServices.genericApiCall("/rgps/list" + paramStr)
        .then((response) => {
          if (response.data) this.lenses = response.data.items;
          if (response.data.meta) this.meta = response.data.meta;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rowClick(item) {
      //   console.log(item);
      let url = `/rgps/details/${item.slug}`;
      //   console.log(url);
      this.$router.push({ path: url });
    },
    // getTagIdForSlug(slug) -->  in mixin

    lensHasTag(lensTags, tagSlug) {
      let id = this.tagIdsForSlugs?.[tagSlug];
      // console.log(lensTags, tagSlug, id);
      return lensTags.includes(id);
    },
    searchChange() {
      this.filters.search = this.search;
    },
    // addRemoveFilterTag(tagId) {
    //   console.log(tagId);
    // },
    companyForItem(item) {
      let id = item.companyId;
      let companies = this.rgpOptions?.companies;
      if (!id || !companies) return null;
      return companies[id]?.name;
    },
    clearFilters() {
      this.search = null;
      this.filters = { search: null, company: null, tags: [], lensType: null };
    },
    summaryChipClicked(summaryObj) {
      if (summaryObj.filterKey) this.filters[summaryObj.filterKey] = null;
      if (summaryObj.filterKey == "search") this.search = "";
      if (summaryObj.tagId)
        this.filters.tags = this.removeTagAndChildren(
          this.filters.tags,
          summaryObj.tagId
        ); // in RgpOptionsMixin()
    },
  },
  computed: {
    isMobile: function () {
      return !this.$vuetify.breakpoint.smAndUp;
    },
    tagTypeImage: function () {
      let rtn = null;
      // let co = this.companyObj;
      // if (co && co.image) rtn = this.companyPath + co.image;
      let key = this.tagTypeKey;
      if (key && this.imagesForKey[key])
        rtn = this.iconPath + this.imagesForKey[key];
      return rtn;
    },
    selectCompanyOptions: function () {
      let companies = this.meta?.companies;
      if (!companies) return null;
      let ids = Object.keys(companies);
      let options = this.companyOptionsForList(ids);
      return options;
    },
    filteredLenses: function () {
      if (!this.lenses) return [];
      let search = this.search;
      let compSlug = this.filters.company;
      let lensType = this.filters.lensType;
      let comp = this.companyIdsForSlugs?.[compSlug];
      // let filterTagSlugs = this.filters.tags;
      // let filterTags = this.tagIdArrForSlugArr(filterTagSlugs);
      let filterTags = this.filters.tags;
      let itemsF = this.lenses.filter((item) => {
        if (comp && item.companyId != comp) return false;
        if (lensType && item.lensType != lensType) return false;

        if (search) {
          search = search.toLowerCase();
          let nameMatch = item.lens.toLowerCase().includes(search);
          // console.log(search, item.name.toLowerCase(), nameMatch);
          let compMatch = item.company.toLowerCase().includes(search);

          if (!nameMatch && !compMatch) return false;
        }

        if (filterTags && filterTags.length) {
          // console.log(filterTags);
          let lensTags = item.tags;
          let tagMatch = true;
          filterTags.forEach((tag) => {
            if (!lensTags.includes(tag)) tagMatch = false;
          });
          if (!tagMatch) return false;
        }
        return true;
      });
      return itemsF;
    },
    // tagFilterOptions: function () {
    //   let tagObj = this.meta?.tags;
    //   if (!tagObj) return null;
    //   let tags = Object.keys(tagObj);
    //   return this.tagOptionsForSelect(tags);
    // },

    tagTypeKey: function () {
      let rtn = null;
      if (this.lensType) {
        rtn = this.lensType;
      } else if (this.tag) {
        rtn = this.tag;
      } else if (!this.companyObj) rtn = "all";
      return rtn;
    },
    pageTitle: function () {
      let rtn = "GP & Specialty Lenses";
      let key = this.tagTypeKey;
      // console.log(key);
      // let tagSlug = this.tag;
      if (key) {
        rtn = this.keyTitles[key]; // from rgpoptionsmixin
      } else if (this.companyObj?.name) {
        rtn = this.companyObj.name;
      }
      if (!rtn && this.tagObj?.name) rtn = this.tagObj.name;
      return rtn;
    },
    companyObj: function () {
      return this.company ? this.companyObjForSlug(this.company) : null;
    },
    tagObj: function () {
      return this.tag ? this.tagObjForSlug(this.tag) : null;
    },
    headersForSize: function () {
      return this.isMobile ? this.mobileHeader : this.headers;
    },

    tagIdsForResults: function () {
      let tagsObj = this.meta?.tags;
      // console.log("hiya");
      let rtn = {
        allowedTags: [], // every tag for all items in this lens list
        universalTags: [], // tags that ALL items in the list include
      };
      if (!this.lenses || !tagsObj || !this.lenses.length) return rtn;
      let lensCount = this.lenses.length;
      let allTagIds = Object.keys(tagsObj);

      // console.log(this.lenses);

      allTagIds.forEach((id) => {
        let cnt = tagsObj[id].length;
        if (cnt > 0) rtn.allowedTags.push(id);
        if (cnt == lensCount) rtn.universalTags.push(id);
      });
      // console.log("tag script");
      return rtn;
    },

    mainTag: function () {
      return this.meta?.search?.tag;
    },
    // the lens types in a given set of lenses
    lensTypesForResults: function () {
      let typesObj = this.meta?.lensTypes;
      if (!typesObj) return null;
      let types = Object.keys(typesObj);
      let rtn = [];
      Object.keys(this.typeOptions).forEach((type) => {
        if (types.includes(type)) rtn.push(type);
      });

      return rtn;
    },
    filterSummary: function () {
      let rtn = [];
      let f = this.filters;
      // console.log(f);
      if (f.search && f.search != "")
        rtn.push({ label: `Name includes '${f.search}'`, filterKey: "search" });
      if (f.company) {
        let company = this.companyNameForSlug(f.company);
        rtn.push({ label: `Company is ${company}`, filterKey: "company" });
      }
      if (f.lensType) {
        rtn.push({ label: `${f.lensType} lens`, filterKey: "lensType" });
      }
      if (f.tags && this.rgpOptions?.tags) {
        f.tags.forEach((tagId) => {
          let tag = this.rgpOptions?.tags?.[tagId]?.name;
          if (tag && tagId !== this.mainTag)
            rtn.push({ label: `${tag}`, tagId: tagId });
        });
      }
      return rtn;
    },
  },
  watch: {
    filters: {
      handler: function () {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      },
      deep: true,
    },
    tagIdsForResults: {
      handler: function (val) {
        if (val?.universalTags && val.universalTags.length)
          this.filters.tags = [...val.universalTags];
      },
      deep: true,
    },
  },
  mounted() {
    if (this.$route.params.company) this.company = this.$route.params.company;
    if (this.$route.params.tag) this.tag = this.$route.params.tag;
    if (this.$route.params.lensType)
      this.lensType = this.$route.params.lensType;
    this.getLenses();

    this.prepend_F = false; // (for FiltersMixin)
    this.keysCase = "lower"; // (for FiltersMixin)
    this.arrayFilterKeys = ["tags"]; // (for FiltersMixin - tell it this field will be an array)
    this.setFiltersFromHash();
    if (this.filters.search) this.search = this.filters.search;
    if (this.filters.tags.length) this.showMoreTags = true;
  },
  metaInfo() {
    return {
      title: "EyeDock/RGPs | " + this.pageTitle,
    };
  },
};
</script>

<style scoped>
.imgDiv {
  width: 120px;
  padding: 10px;
}
</style>
